import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header.js";
import "../../assets/styles/local/DashBoard.css";
import { useDispatch, useSelector } from "react-redux";
import {
  IsActiveWidget,
  fetchTranslationData,
} from "../../redux/actions/action";
import MapCard from "../../components/DashBoard/MapCard.js";
import ProjectCard from "../../components/DashBoard/ProjectCard.js";
import WorkerCard from "../../components/DashBoard/WorkerCard.js";
import TopProjectCard from "../../components/DashBoard/TopProjectCard.js";
import InventoryCard from "../../components/DashBoard/InventoryCard.js";
import OnBoardCard from "../../components/DashBoard/OnBoardCard.js";
import CashFlowCard from "../../components/DashBoard/CashFlowCard.js";
import AccountCard from "../../components/DashBoard/AccountCard.js";
import { fetchScreenTranslations } from "../../utils/helpers/translations.js";

const DashBoard = () => {
  const dispatch = useDispatch();
  const companyid = window.localStorage.getItem("companyid");
  const WidgetResponse = useSelector((state) => state.user.dashboardWidgets);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    dispatch(IsActiveWidget(companyid));
  }, [dispatch]);

  const renderComponent = (widgetName) => {
    switch (widgetName) {
      case "MapCard":
        return <MapCard />;
      case "ProjectCard":
        return <ProjectCard />;
      case "WorkerCard":
        return <WorkerCard />;
      case "TopProjectCard":
        return <TopProjectCard />;
      case "InventoryCard":
        return <InventoryCard />;
      case "OnboardCard":
        return <OnBoardCard />;
      case "CashflowCard":
        return <CashFlowCard />;
      case "AccountCard":
        return <AccountCard />;

      default:
        return null;
    }
  };

  return (
    <>
      <Header
        leftComponent={
          <div className="headerContainer">
            <div className="dashboardTitle">
              {/* Dashboard */}
              {t("Dashboard")}
            </div>
          </div>
        }
      />

      <div className="parent">
        {WidgetResponse.filter((x) => x.isActive).map((widget) => (
          <div key={widget.widgedid}>{renderComponent(widget.widgedName)}</div>
        ))}
      </div>
    </>
  );
};

export default DashBoard;
